import {
  BrowserRouter,
  Route,
  Routes as ReactRouterRoutes,
} from 'react-router-dom';

import JobsV2App from 'hb-react/frontoffice/apps/JobsV2';
import { WithAppPageConfig } from 'hb-react/frontoffice/utils/page';
import {
  ROUTE_TAG_FEATURES,
  ROUTE_TAG_APP_PAGES,
} from 'hb-react/publicoffice/constants/routeTags';
import PublicOfficeApp from 'hb-react/publicoffice/providers/App';
import useNetworkConfiguration from 'hb-react/publicoffice/utils/useNetworkConfiguration';

const JobsAppStandalone = (props) => {
  const { networkConfiguration } = useNetworkConfiguration({
    networkConfigurationOptions: ['business_opportunities'],
    networkRouteTags: [
      {
        routeTag: ROUTE_TAG_FEATURES,
        params: { app_names: ['opportunities'] },
      },
      {
        routeTag: ROUTE_TAG_APP_PAGES,
        params: { app_name: 'opportunities' },
      },
    ],
  });

  if (networkConfiguration) {
    const {
      colors,
      theming,
      styles,
      networkConfigData,
      featuresData,
      appPagesData,
    } = networkConfiguration;

    const {
      features: {
        opportunities: { extraData },
      },
    } = featuresData;
    const {
      avatar_thumb_url: avatarThumbUrl,
      title,
      user_fields_config: userFieldsConfig,
    } = extraData;

    const customNetwork = {
      app_pages: [appPagesData],
      network_configuration: networkConfigData,
      avatar_thumb_url: avatarThumbUrl,
      title,
      user_fields_config: userFieldsConfig,
      colors: colors.colors,
      styles: styles.styles,
      theming: theming.theming,
    };

    return (
      <PublicOfficeApp network={customNetwork}>
        <WithAppPageConfig identifier="business_opportunities" withMenu={false}>
          {({ appPageConfig }) => (
            <BrowserRouter>
              <ReactRouterRoutes>
                <Route
                  path="/opportunities/*"
                  element={<JobsV2App configPage={appPageConfig} {...props} />}
                />
              </ReactRouterRoutes>
            </BrowserRouter>
          )}
        </WithAppPageConfig>
      </PublicOfficeApp>
    );
  }

  return null;
};

export default JobsAppStandalone;
